module.exports = __webpack_public_path__ + "media/stylesheets/images/folk_logo-bd78831aa9b3710267b506c5e600e718.png";